/** Strates de récence selon la dernière apparition en jeu. */
export const REGISTER_RECENCY_STRATA = [
  {
    id: "veryRecent",
    title: "Très récemment joués",
    subtitle: "Jusqu'à 3 jours",
    /** [0 ; 3] jours inclus */
    minDaysExclusive: null,
    maxDaysInclusive: 3,
  },
  {
    id: "recent",
    title: "Récemment joués",
    subtitle: "Plus de 3 jours et jusqu'à 7 jours",
    minDaysExclusive: 3,
    maxDaysInclusive: 7,
  },
  {
    id: "lessRecent",
    title: "Moins récemment joués",
    subtitle: "Plus de 7 jours et jusqu'à 15 jours",
    minDaysExclusive: 7,
    maxDaysInclusive: 15,
  },
  {
    id: "awhile",
    title: "Pas joués depuis un bon moment",
    subtitle: "Plus de 15 jours et jusqu'à 30 jours",
    minDaysExclusive: 15,
    maxDaysInclusive: 30,
  },
  {
    id: "longAgo",
    title: "Pas joués depuis longtemps",
    subtitle: "Plus de 30 jours",
    minDaysExclusive: 30,
    maxDaysInclusive: null,
  },
];

export const DEFAULT_REGISTER_RECENCY_STRATUM = REGISTER_RECENCY_STRATA[0].id;

export function sanitizeRegisterRecencyStratum(value) {
  return REGISTER_RECENCY_STRATA.some((stratum) => stratum.id === value)
    ? value
    : DEFAULT_REGISTER_RECENCY_STRATUM;
}
